export default __webpack_public_path__ + "static/media/sub-category-hair-beauty-beauty-space.4c4c11fb.jpg";